import { Validation, ValidationTypes } from "../../../validation/constants";
import { isValidNumber } from "../../../utilities/number";

const VALIDATIONS_NUMBER: Array<Validation> = [
  {
    type: ValidationTypes.ERROR,
    message: "numberEntity.errors.invalid",
    icon: "ExclamationCircle",
    requiresValue: true,
    validate: isValidNumber,
  },
];

export default VALIDATIONS_NUMBER;
